import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {environment} from '../environments/environment';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {CoreModule} from './core/core.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {PagesModule} from './pages/pages.module';
import {StoreModule} from '@ngrx/store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {reducers} from './reducers';
import {EffectsModule} from '@ngrx/effects';
import {AgmCoreModule} from '@agm/core';
import {HttpClientModule} from '@angular/common/http';
import {AuthGuard} from './services/auth_guard.service';
import {UserInfoService} from './services/user-info.service';
import {ApiRequestService} from './services/api/api-request.service';
import {LoginService} from './services/api/login.service';
import {AppConfig} from './app-config';
import {LogoutComponent} from './pages/auth/logout/logout.component';
import {LoaderModule} from './core/loader/loader.module';
import {CommonService} from './services/api/common.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DeviationService} from './services/api/deviation.service';
import {RolesService} from './services/api/roles.service';
import {UsersService} from './services/api/users.service';
import {PermissionService} from './services/api/permissions.service';
import {ColdStoreService} from './services/api/cold-store.service';
import {ProfileService} from './services/api/profile.service';
import {DeviationTypeService} from './services/api/deviation-type.service';
import {VendorService} from './services/api/vendor.service';
import {ClientService} from './services/api/client.service';
import {OperatorService} from './services/api/operator.service';
import {CommodityService} from './services/api/commodity.service';
import {ProfileTypeService} from './services/api/profile-type.service';
import {RegionService} from './services/api/region.service';
import {SiteService} from './services/api/site.service';
import {ViewQRService} from './services/api/view-qr.service';
import {EscalationService} from './services/api/escalation.service';
/*import {MainComponent} from './main/main.component';
import {AmChartsModule} from "@amcharts/amcharts3-angular";

import {MainModule} from './main/main.module';*/
/*import {RedirectsModule} from './redirects/redirects.module';*/
import {DataService} from './services/api/data-service';
import {EmployeeService} from './services/api/employee.service';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {UserService} from './services/api/user.service';
import {AmChartsModule} from '@amcharts/amcharts3-angular/';
import {NgxPermissionsModule} from 'ngx-permissions';
import {MatDialogModule} from '@angular/material/dialog';
import { RouteHandlerModule } from './core/route-handler/route-handler.module';

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        StoreModule.forRoot(reducers),
        !environment.production ? StoreDevtoolsModule.instrument({maxAge: 50}) : [],
        EffectsModule.forRoot([]),
        AgmCoreModule.forRoot({
            apiKey: environment.googleMapsApiKey
        }),
        AppRoutingModule,
        CoreModule,
        PagesModule,
        LoaderModule,
        ReactiveFormsModule,
        FormsModule,
        MatSnackBarModule,
        AmChartsModule,
        MatDialogModule,
        RouteHandlerModule,
        NgxPermissionsModule.forRoot()
    ],
    providers: [
        AuthGuard,
        UserInfoService,
        ApiRequestService,
        LoginService,
         AppConfig,
        LoginService, ApiRequestService, AppConfig, UserInfoService,
         CommonService, EmployeeService,
         ColdStoreService, RolesService, PermissionService,  UserService,  DeviationService, DataService,         {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        }, UsersService, ProfileService, DeviationTypeService, VendorService, ClientService, OperatorService, CommodityService,
        ProfileTypeService, RegionService, SiteService, ViewQRService, EscalationService
    ],
    declarations: [
        LogoutComponent,
        AppComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
